import { Pipe, PipeTransform } from '@angular/core';
import {
  ScheduleTypeEnum,
  ScheduleTypeInfo,
} from '@qaroni-app/work-calendar/types/schedule-type.enum';

@Pipe({
  name: 'scheduleType',
  standalone: false,
})
export class ScheduleTypePipe implements PipeTransform {
  transform(value: ScheduleTypeEnum): string {
    return value &&
      Object.prototype.hasOwnProperty.call(ScheduleTypeInfo, value)
      ? ScheduleTypeInfo[value].name
      : value;
  }
}
